import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  setStageModalOpen,
  setStagePage,
  get_stage_list,
  create_stage,
  update_stage,
  setAction,
  setId,
  setStatus,
  setSearchQuery,
  activate_deactivate_stage,
  get_stage_details
} from "../../../store/stage/stageSlice";
import { get_sidebar_menu_list } from "../../../store/assigntoprocess/assignprocessSlice";

const mapStateToProps = (state) => {
  const {
    is_stage_modal_open,
    stage_list,
    common_loading,
    total_stage_count,
    active_stage,
    page,
    c_action,
    stage_id,
    selected_status,
    search_query,
    selected_data
  } = state.stage;

  const { sidebar_menu_list } = state.assign_process;

  return {
    is_stage_modal_open: is_stage_modal_open,
    stage_list: stage_list,
    total_stage_count: total_stage_count,
    common_loading: common_loading,
    active_stage: active_stage,
    page: page,
    c_action: c_action,
    stage_id: stage_id,
    selected_status: selected_status,
    search_query: search_query,
    selected_data: selected_data,
    sidebar_menu_list: sidebar_menu_list
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    setStageModalOpen,
    setStagePage,
    get_stage_list,
    create_stage,
    update_stage,
    setAction,
    setId,
    setStatus,
    setSearchQuery,
    activate_deactivate_stage,
    get_stage_details,
    get_sidebar_menu_list
  }, dispatch);

const Store = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;